import { Box } from "@mui/material";
import { DeploymentEnvironmentName, environmentConfig } from "@src/appV2/environment";
import { REBRAND_PRIMARY_COLOR } from "@src/appV2/lib/Theme/rebrandConstants";

const ENVIRONMENT_LABELS: Partial<Record<DeploymentEnvironmentName, string>> = {
  [DeploymentEnvironmentName.LOCAL]: "LOCAL",
  [DeploymentEnvironmentName.DEVELOPMENT]: "DEV",
  [DeploymentEnvironmentName.STAGING]: "STAGING",
  [DeploymentEnvironmentName.PROD_SHADOW]: "PROD-SHADOW",
  [DeploymentEnvironmentName.PROD_RECREATED]: "PROD-RECREATED",
};

export function EnvironmentChip() {
  const envName = environmentConfig.REACT_APP_ENVIRONMENT_NAME as DeploymentEnvironmentName;
  const label = ENVIRONMENT_LABELS[envName];

  if (!label) {
    return null;
  }

  return (
    <Box
      component="span"
      role="status"
      aria-label={`Environment: ${label}`}
      sx={{
        display: "inline-block",
        paddingX: "6px",
        paddingY: "1px",
        borderRadius: "3px",
        backgroundColor: REBRAND_PRIMARY_COLOR,
        color: "#FFFFFF",
        fontSize: "10px",
        fontWeight: 700,
        lineHeight: 1.4,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
      }}
    >
      {label}
    </Box>
  );
}
